<reset-password-link-form
[appName]="appName"
 (passwordLinkData)="resetPassword($event)" 
 [isPasswordLinkSent]="isPwdLinkSent"
 [appName]="appName"
 >
</reset-password-link-form>